<template>
  <div class="xy-survey-btn" ref="componentRef"></div>
</template>

<script setup>
import { info, defaultProps } from './config'
import { useSurvey } from '@/packages/components/hook/useSurvey'

defineOptions({ name: info.name })
const props = defineProps(defaultProps)

const { componentRef, getConfig, submitFormBtn } = useSurvey(props)

defineExpose({
  getConfig,
  submitFormBtn
})
</script>

<style lang="scss" scoped>
.xy-survey-btn {
  position: absolute;
  width: 0px;
  height: 0px;
  display: flex;
  top: -10px;
  left: -10px;
  z-index: -999;
}
</style>
